<div class="management-container-wrapper">

  <div class="management-container">
    <h3>Gestión de Competiciones</h3>
    <p>Añade o edita las competiciones del sistema.</p>

    <div class="add-item-form">
      <input
        type="text"
        [(ngModel)]="newCompetitionName"
        placeholder="Nombre de la nueva competición"
        (keyup.enter)="addCompetition()">
      <button (click)="addCompetition()" class="add-button" [disabled]="!newCompetitionName.trim()">Añadir</button>
    </div>

    <div class="item-list">
      @for (competition of competitions; track competition.id || competition.name; let i = $index) {
        <div class="item-card">
          <input type="text" [(ngModel)]="competition.name" class="item-name-input" placeholder="Nombre de competición">
<!--
          TODO: Manejar el tema de elminación.
          <button class="delete-button" (click)="removeCompetition(i)" title="Eliminar competición">×</button>
-->
        </div>
      }
    </div>

    <div class="actions">
      <button (click)="saveChanges()" class="primary" [disabled]="isLoading">Guardar Cambios</button>
    </div>
  </div>


</div>
